// Literals
const STRING_LITERAL = 'STRING_LITERAL';
const NUMERIC_LITERAL = 'NUMERIC_LITERAL';

// References
const IDENTIFIER = 'IDENTIFIER';
const FIELD = 'FIELD';

// Functions
const FUNCTION_CALL = 'FUNCTION_CALL';
const PARTIAL_FUNCTION_CALL = 'PARTIAL_FUNCTION_CALL';
const PARTIAL_FUNCTION_EMPTY_ARGUMENT = 'PARTIAL_FUNCTION_EMPTY_ARGUMENT';

// Binary Operators
const ADD = 'ADD';
const SUBTRACT = 'SUBTRACT';
const MULTIPLY = 'MULTIPLY';
const DIVIDE = 'DIVIDE';

// Array types
const ARRAY = 'ARRAY';
const ARRAY_ELEMENT = 'ARRAY_ELEMENT';

// Unary Operators
const NEGATIVE = 'NEGATIVE';
const POSITIVE = 'POSITIVE';

// String template types
const FORMULA = 'FORMULA';
const ExpressionTypes = {
  STRING_LITERAL,
  NUMERIC_LITERAL,
  IDENTIFIER,
  FIELD,
  FUNCTION_CALL,
  PARTIAL_FUNCTION_CALL,
  PARTIAL_FUNCTION_EMPTY_ARGUMENT,
  ARRAY,
  ARRAY_ELEMENT,
  ADD,
  SUBTRACT,
  MULTIPLY,
  DIVIDE,
  NEGATIVE,
  POSITIVE,
  FORMULA
};
export default ExpressionTypes;